import type { AxiosInstance } from 'axios'
import URI from 'urijs'

import { Pagination } from '../../interfaces/common'
import { ProductListInterface } from '../../interfaces/product'

export const getCompanyProductList = (api: AxiosInstance) => (
  companyId: string,
  page = 1,
  limit?: number,
  sortBy?: string,
  sortDirection?: string,
  isDeleted?: boolean,
  ...args: any[]
): Promise<Pagination<ProductListInterface>> =>
  api.get(
    `/v1.0/admin/products/company/${companyId}?` +
      URI.buildQuery({
        page,
        limit,
        sortBy,
        sortDirection,
        isDeleted
      }),
    ...args
  )
